import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import secondsToHms from '../SecondsToHms/secondsToHms';
import { useHistory } from "react-router-dom";
import Rating from '../Rating/Rating';

function Card(props) {
    const history = useHistory();

    const goToCourseDetails = (cid) => {
        history.push({
            pathname: `/course-details`,
            state: {
                cid
            }
        });
    }

    const startUi = (e) => {
        if (e.progressPercent === 0) {
            return <button className="btn" type="button" onClick={() => props.playCourse(e.id)}>Start</button>
        } else if (e && e.progressPercent > 0) {
            return <button className="btn" type="button" onClick={() => props.playCourse(e.id)}>Continue</button>
        }
    }

    return (
        <React.Fragment>
            <div className='card-block'>
                <div className='card-img-block cp' onClick={() => goToCourseDetails(props.data.id)}>
                    <img src={props.data.imageUrl} alt='Loading' />
                    <span>{props.data.loFormat}</span>
                </div>
                <div className='card-content'>
                    <div className='card-title cp' onClick={() => goToCourseDetails(props.data.id)}>
                        {props.data.name}
                    </div>
                    <div className='time-recent'>
                        <span>{props.data.skills}</span>
                        {/* {props.data.duration > 0 && */}
                        <React.Fragment>
                            <span style={{ visibility: props.data.duration != 0 ? 'visible' : 'hidden' }}><span className='small-separator'>
                            </span>{secondsToHms(props.data.duration)}</span>
                        </React.Fragment>
                        {/* } */}
                    </div>
                    <div className='card-button'>
                        <span className='star'>
                            <Rating number={props.data.averageRating}></Rating>
                        </span>
                        {props.enrollToCourse ?
                            <div className='star-btn'>
                                <button className='btn' disabled={props.data.enrollment} onClick={() => props.enrollToCourse(props.data.id, props.data.instancesId)}>Enroll</button></div> :
                            startUi(props.data)
                        }

                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default Card;
